import createReducer from 'store/create-reducer';
import apiFetch from 'utils/apiFetch';
import _ from 'lodash';
import { loadingAction } from 'store/globalState/global';
import { sendNotificationToRoom } from 'modules/socket/actions';
import { USER_BASE_ROOM, SEPARATOR_NAME_ROOM, INSTALLATION_CODE } from 'modules/socket/constants';
import { CHAT_TYPE_THEME_TABLE, CHAT_TYPE_CALL_FOR_IMPACT } from 'constants/chat';
import { ROOM_CALL_FOR_IMPACT, ROOM_THEME_TABLE } from 'constants/rooms';
import history from 'store/history';
import { STATUS_SAVING, STATUS_SAVED } from 'constants/status';
import * as NOTIFICATIONS from 'constants/notifications';
import initialState from 'store/globalState/initialState';
import * as ACTION_TYPES from './types';

const INITIAL_STATE = initialState.chats;

const handleChats = chats => (dispatch) => {
  dispatch({ type: ACTION_TYPES.FETCH_USER_CHATS, chats });
};

export const sendFile = (data, message, callback) => () => {
  const params = {
    document_file: message.file,
  };

  apiFetch('POST', { endPoint: 'upload-resource' }, params, 1)
    .then((response) => {
      const params2 = {
        ...message,
        hash: response.info.hash,
        temp_id: message.temp_id,
      };

      apiFetch('POST', { endPoint: `chat/${message.chat_id}/attachment` }, params2).then(() => {
        callback();
      });
    });
};
export const viewDocument = (hash, bp) => {
  const params = {
    actual_bp: bp,
    h: hash,
  };
  return apiFetch('GET', { endPoint: 'documents/view' }, params);
};
export const markChatAsRead = chatId => (dispatch, getState) => {
  const user = getState().session.user.id;
  const chats = getState().chats.chats;
  const chat = _.find(chats, { id: chatId });
  if (chat && chat.last_message && _.findIndex(chat.last_message.users_read, u => u === user) === -1) {
    apiFetch('POST', { endPoint: 'chat/read' }, { chat_id: chatId });
    dispatch({ type: ACTION_TYPES.SET_CHAT_AS_READ, chatId, user });
  }
};

export const addNewChat = chat => (dispatch, getState) => {
  const chats = getState().chats.chats;
  if (!_.find(chats, { id: chat.id })) {
    chats.push(chat);
    dispatch(handleChats(chats));
  }
};

export const fetchUserChats = () => (dispatch) => {
  apiFetch('GET', { endPoint: 'users/chats' })
    .then((chats) => {
      dispatch(handleChats(chats));
    });
};

export const sendMessage = message => (dispatch, getState) => {
  apiFetch('POST', { endPoint: 'message' }, message);

  const chat = _.find(getState().chats.chats, { id: message.chat_id });
  if (chat) {
    // Send notification to room
    const newMessage = Object.assign({}, message);
    newMessage.read = 0;
    newMessage.type = 'text';

    let room = false;
    switch (chat.element_related.type_id) {
      case CHAT_TYPE_THEME_TABLE:
        room = `${INSTALLATION_CODE}${SEPARATOR_NAME_ROOM}${ROOM_THEME_TABLE}${SEPARATOR_NAME_ROOM}${chat.element_related.id}`;
        break;
      case CHAT_TYPE_CALL_FOR_IMPACT:
        room = `${INSTALLATION_CODE}${SEPARATOR_NAME_ROOM}${ROOM_CALL_FOR_IMPACT}${SEPARATOR_NAME_ROOM}${chat.element_related.id}`;
        break;
      default:
        break;
    }
    sendNotificationToRoom(room, ACTION_TYPES.NEW_MESSAGE, { message: JSON.stringify(newMessage) });
  }
};

export const fetchChat = chatId => (
  apiFetch('GET', { endPoint: `chat/${chatId}` })
);

export const getOlderMessages = () => (dispatch, getState) => {
  const { chats: { selectedChat } } = getState();

  if (selectedChat) {
    const firstMessage = selectedChat.messages[0].id;
    const chatId = selectedChat.id;
    dispatch({ type: ACTION_TYPES.SET_IS_LOADING_OLDER, isLoadingOlder: true });
    apiFetch('GET', { endPoint: `chat/${chatId}/messages` }, { before_than: firstMessage })
      .then((response) => {
        const newMessages = _.uniqBy(selectedChat.messages.concat(response), 'id');
        const orderMessages = _.orderBy(newMessages, ['timestamp'], ['asc']);
        selectedChat.messages = orderMessages;
        dispatch({ type: ACTION_TYPES.SET_SELECTED_CHAT, selectedChat });
        dispatch({ type: ACTION_TYPES.SET_IS_LOADING_OLDER, isLoadingOlder: false });
      });
  }
};

export const resetSelectedChat = () => (dispatch) => {
  dispatch({ type: ACTION_TYPES.SET_SELECTED_CHAT, selectedChat: null });
};

export const leaveChat = chatId => (dispatch) => {
  const params = {
    chatId,
  };
  dispatch({ type: ACTION_TYPES.LEAVE_CHAT, params });
  dispatch(loadingAction(true));
  apiFetch('POST', { endPoint: `chat/${chatId}/leave` }).then(() => {
    history.push('/think');
    dispatch(loadingAction(false));
  }).catch((error) => {
    console.error('couldn´t leave chat', error);
    dispatch(loadingAction(false));
  });
};

export const killSeed = (user, chatId) => (dispatch) => {
  const params = {
    userId: user.id,
    chatId,
  };
  dispatch({ type: ACTION_TYPES.LEAVE_CHAT, params });
  return apiFetch('POST', { endPoint: `chat/${chatId}/leave` });
};

export const getInvitations = () => (dispatch) => {
  apiFetch('GET', { endPoint: 'think-seed/invitations' }).then((response) => {
    dispatch({ type: ACTION_TYPES.GET_INVITATIONS, invitations: response });
  });
};

export const rejectInvitation = (id, callback) => (dispatch) => {
  apiFetch('POST', { endPoint: `invitation/${id}/reject ` }).then(() => {
    dispatch({ type: ACTION_TYPES.REJECT_INVITATION, id });
    callback();
  });
};

export const acceptInvitation = (invitation, thinkSeedId, callback) => (dispatch) => {
  dispatch({ type: ACTION_TYPES.ACCEPT_INVITATION, invitation });
  callback();
};

export const setAsLeader = (thinkSeedId, userId) => (dispatch) => {
  dispatch({ type: ACTION_TYPES.UPDATE_CHAT_INIT });
  apiFetch('POST', { endPoint: `think-seed/${thinkSeedId}/leader/${userId}` })
    .then((chat) => {
      dispatch({ type: ACTION_TYPES.UPDATE_CHAT, chat });
      dispatch({ type: ACTION_TYPES.SET_SELECTED_CHAT, selectedChat: chat });
    });
};

export const setSelectChatImage = urlImage => (dispatch) => {
  dispatch({ type: ACTION_TYPES.UPDATE_CHAT_IMAGE, image: urlImage });
};

export const fetchThinkTanks = (userId) => {
  return apiFetch('GET', { endPoint: `users/${userId}/think-tanks` });
};

const handleNewNotification = (state, action) => {
  const { payload } = action;
  const newState = Object.assign({}, state);
  switch (payload.req_message) {
    case NOTIFICATIONS.NEW_TABLE_JOINED: {
      const chat = JSON.parse(payload.chat);
      const chats = state.chats ? [...state.chats] : null;
      if (chats && !_.find(chats, { id: chat.id })) {
        chats.push(chat);
      }

      return {
        ...state,
        chats,
      };
    }
    case NOTIFICATIONS.NEW_MESSAGE: {
      const message = JSON.parse(payload.message);
      newState.newMessage = { ...message };
      let found = false;
      if (newState.chats) {
        for (let i = 0; i < newState.chats.length; i += 1) {
          if (newState.chats[i].id === parseInt(message.chat_id, 10)) {
            newState.chats[i].last_message = message;
            found = true;
          }
        }
      }

      if (!found) {
        newState.mustReloadChats = true;
      }
    }
      break;
    case NOTIFICATIONS.NEW_THINK_CHAT_INVITATION: {
      const invitation = JSON.parse(payload.invitation);
      const { invitations } = state;

      if (!_.find(invitations, { id: invitation.id })) {
        invitations.push(invitation);
      }

      return {
        ...state,
        invitations,
      };
    }
    default:
      break;
  }
  return newState;
};

const ACTION_HANDLERS = {
  [ACTION_TYPES.GET_INVITATIONS]: (state, { invitations }) => (
    {
      ...state,
      invitations,
      mustReloadInvitations: false,
    }),
  [ACTION_TYPES.FETCH_USER_CHATS]: (state, { chats }) => ({
    ...state,
    chats: [...chats],
    mustReloadChats: false,
  }),
  [ACTION_TYPES.SET_SELECTED_CHAT]: (state, { selectedChat }) => ({
    ...state,
    selectedChat,
  }),
  [ACTION_TYPES.SET_CHAT_AS_READ]: (state, { chatId, user }) => {
    const newState = Object.assign({}, state);

    if (newState.chats) {
      for (let i = 0; i < newState.chats.length; i += 1) {
        if (newState.chats[i].id === chatId) {
          if (!newState.chats[i].last_message) {
            newState.chats[i].last_message = {};
          }

          if (!newState.chats[i].last_message.users_read) {
            newState.chats[i].last_message.users_read = [];
          }
          newState.chats[i].last_message.users_read.push(user);
        }
      }
    }
    return newState;
  },
  [ACTION_TYPES.NOTIFICATION]: (state, action) => {
    return handleNewNotification(state, action);
  },
  [ACTION_TYPES.NOTIFICATION_TO_ROOM]: (state, action) => {
    return handleNewNotification(state, action);
  },
  [ACTION_TYPES.SET_IS_LOADING_OLDER]: (state, { isLoadingOlder }) => ({
    ...state,
    isLoadingOlder,
  }),
  [ACTION_TYPES.LEAVE_CHAT]: (state, { params }) => {
    const chats = _.filter(state.chats, chat => chat.id !== params.chatId);

    return {
      ...state,
      chats,
    };
  },
  [ACTION_TYPES.REJECT_INVITATION]: (state, { id }) => {
    const invitations = _.filter(state.invitations, invitation => invitation.id !== id);

    return {
      ...state,
      invitations,
    };
  },
  [ACTION_TYPES.ACCEPT_INVITATION]: (state, { invitation }) => {
    const invitations = _.filter(state.invitations, inv => invitation.id !== inv.id);
    return {
      ...state,
      invitations,
    };
  },

  [ACTION_TYPES.UPDATE_CHAT_INIT]: state => ({
    ...state,
    selectLeaderStatus: STATUS_SAVING,
  }),
  [ACTION_TYPES.UPDATE_CHAT]: (state, { chat }) => {
    const { chats } = state;
    _.remove(chats, { id: chat.id });
    chats.push(chat);

    const newState = { ...state };
    newState.chats = chats;
    newState.selectLeaderStatus = STATUS_SAVED;
    return newState;
  },
  [ACTION_TYPES.UPDATE_CHAT_IMAGE]: (state, { image }) => {
    const { selectedChat } = state;
    selectedChat.element_related.image = image;
    const newState = { ...state };
    newState.selectedChat = selectedChat;
    return newState;
  },
};

export default createReducer(INITIAL_STATE, ACTION_HANDLERS);



// WEBPACK FOOTER //
// ./src/modules/chats/index.js